<mat-icon (click)="prev()">chevron_left</mat-icon>
<span
    #triger
    class="st-date-range-pager-label"
    (click)="toggleDatePickerPopOver(picker)">
    {{ label() }}
</span>
<mat-form-field class="st-date-range-pager-form-field">
    <input
        matInput
        hidden
        [matDatepicker]="picker"
        [ngModel]="dateValue()"
        (dateChange)="dateValueChanged($event)" />
    <mat-datepicker #picker />
</mat-form-field>
<mat-icon (click)="next()">chevron_right</mat-icon>
